import { Page, withModel } from '@adobe/aem-react-editable-components';
import React from 'react';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import'@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import {Modal} from './components/Shared/Modal/Modal';

// This component is the application entry point
class App extends Page<any, any> {
  render() {
    return (
      <>
        {this.childComponents}
        {this.childPages}
        <Modal />
      </>
    );
  }
}

export default withModel(App);
